import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../utils/api";
import paths from "../utils/paths";

export const useReportHealth = (id, agency_id, status, page = 1, limit = 20) => {
    return useQuery({
        queryKey: ['reportHealth', id, agency_id, status, page, limit],
        queryFn: async () => {
            const url = id ? `${paths.reportHealth}/${id}` : paths.reportHealth;
            const params = {};
            
            if (agency_id) {
                params.agency_id = agency_id;
            }
            
            if (status && status !== 'all') {
                params.status = status;
            }
            
            // Add pagination parameters
            params.page = page;
            params.limit = limit;
            
            const response = await axiosInstance.get(url, { params });
            return response.data;
        },
        retry: false,
    });
};